<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          >Add New
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Add Contact</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form1"
              v-model="valid1"
            >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.name"
                  label="Contact Name"
                  type="text"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.email"
                  label="Contact Email"
                  type="email"
                  :rules="emailRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.mobile"
                  label="Mobile No"
                  type="number"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="success darken-1" text :disabled="!valid1" @click="addcontact1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
  export default {
    props : {
        projectid : Number
    },
    data: function() {
      return {
        vaild1: true,
        dialog: false,
        contact: {
            name : '',
            email: '',
            mobile: '',
            project_id: this.projectid
        },
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
      }
    },
    methods:{
      ...mapActions(['addcontact']),
      addcontact1() {
        if(this.$refs.form1.validate())
        {
          this.addcontact(this.contact);
          this.dialog = false;
        }
      }
    }
  }
</script>